import React from 'react';
import {
  ActionButton,
  HelpText,
  SecondaryButton,
  SectionTitle,
  TextMono
} from '../styles';

type Props = {
  boletoLine?: string;
  boletoPdfUrl?: string;
  boletoDueAt?: string;
  onCopy: (value: string) => void;
};

const BoletoPaymentView: React.FC<Props> = ({
  boletoLine,
  boletoPdfUrl,
  boletoDueAt,
  onCopy
}) => {
  return (
    <>
      <SectionTitle>Pagamento via boleto</SectionTitle>

      <HelpText>
        Vencimento:{' '}
        <strong>
          {boletoDueAt ? new Date(boletoDueAt).toLocaleDateString('pt-BR') : '—'}
        </strong>
      </HelpText>

      {boletoLine && (
        <>
          <HelpText>Copie a linha digitável e pague no app do banco ou em qualquer banco.</HelpText>
          <TextMono>{boletoLine}</TextMono>
          <ActionButton type="button" onClick={() => onCopy(boletoLine)}>
            Copiar linha digitável
          </ActionButton>
        </>
      )}

      {boletoPdfUrl && (
        <SecondaryButton
          type="button"
          onClick={() => window.open(boletoPdfUrl, '_blank', 'noopener,noreferrer')}
        >
          Baixar boleto (PDF)
        </SecondaryButton>
      )}

      {!boletoLine && !boletoPdfUrl && (
        <HelpText>
          Os dados do boleto ainda não estão disponíveis. Atualize a página em instantes ou entre em
          contato com quem enviou esta cobrança.
        </HelpText>
      )}
    </>
  );
};

export default BoletoPaymentView;
